export default __webpack_public_path__ + "static/media/lookup-icon.png?.842aac4f";